export default __webpack_public_path__ + "static/media/yacht.20fa90e6.webp";